import '../components/header/js/nav';
import '../components/faq/js/faq';
import '../components/featured-rotator/js/featured-rotator';
import '../components/lightbox/js/lightbox';
import '../components/notification-bar/js/notification-bar';

import Newsletter from '../components/newsletter/js/newsletter';
Newsletter();
